import { ReactComponent as Icon1 } from '../images/Catalog Coffee/icon01.svg';
import { ReactComponent as Icon2 } from '../images/Catalog Coffee/icon02.svg';
import { ReactComponent as Icon3 } from '../images/Catalog Coffee/icon03.svg';
import { ReactComponent as Icon4 } from '../images/Catalog Coffee/icon04.svg';
import { ReactComponent as Icon5 } from '../images/Catalog Coffee/icon05.svg';
import { ReactComponent as Icon6 } from '../images/Catalog Coffee/icon06.svg';
import { ReactComponent as Icon7 } from '../images/Catalog Coffee/icon07.svg';
import { ReactComponent as Icon8 } from '../images/Catalog Coffee/icon08.svg';
import { ReactComponent as HeaderIcon1 } from '../images/header/01.svg';
import { ReactComponent as HeaderIcon2 } from '../images/header/02.svg';
import { ReactComponent as HeaderIcon3 } from '../images/header/03.svg';
import catalog01 from '../images/catalog/01.png';
import catalog01Webp from '../images/catalog/01.webp';
import catalog02 from '../images/catalog/02.png';
import catalog02Webp from '../images/catalog/02.webp';
import catalog03 from '../images/catalog/03.png';
import catalog03Webp from '../images/catalog/03.webp';
import catalog04 from '../images/catalog/04.png';
import catalog04Webp from '../images/catalog/04.webp';
import discImg01 from '../images/Discount Goods/01.png';
import discImg01Webp from '../images/Discount Goods/01.webp';
import coffee from '../images/Discount Goods/coffee.png';
import coffeeWebp from '../images/Discount Goods/coffee.webp';
import dots from '../images/Discount Goods/dots.png';
import stars from '../images/Discount Goods/stars.png';
import starsWebp from '../images/Discount Goods/stars.webp';
import procent from '../images/Discount Goods/procent.svg';
import procentWebp from '../images/Discount Goods/procent.webp';
import advantages01 from '../images/advantages/01.png';
import advantages01Webp from '../images/advantages/01.webp';
import advantagesicon1 from '../images/advantages/icon1.svg';
import advantagesicon2 from '../images/advantages/icon2.svg';
import advantagesicon3 from '../images/advantages/icon3.svg';
import socialNetworksIcon01 from '../images/socialNetworks/icon01.png';
import socialNetworksIphones from '../images/socialNetworks/iphones.png';
import socialNetworksIphonesWebp from '../images/socialNetworks/iphones.webp';
import socialNetworksNext from '../images/socialNetworks/next.png';
import CatalogCoffee5 from '../images/Catalog Coffee/coffee5.png';
import CatalogCoffee5Webp from '../images/Catalog Coffee/coffee5.webp';
import CatalogCoffee4 from '../images/Catalog Coffee/coffee4.png';
import CatalogCoffee4Webp from '../images/Catalog Coffee/coffee4.webp';
import CatalogCoffee3 from '../images/Catalog Coffee/coffee3.png';
import CatalogCoffee3Webp from '../images/Catalog Coffee/coffee3.webp';
import CatalogCoffee2 from '../images/Catalog Coffee/coffee2.png';
import CatalogCoffee2Webp from '../images/Catalog Coffee/coffee2.webp';
import CatalogCoffee1 from '../images/Catalog Coffee/coffee1.png';
import CatalogCoffee1Webp from '../images/Catalog Coffee/coffee1.webp';
import tea01 from '../images/TeaCatalog/01.png';
import tea01Webp from '../images/TeaCatalog/01.webp';
import tea02 from '../images/TeaCatalog/02.png';
import tea02Webp from '../images/TeaCatalog/02.webp';
import tea03 from '../images/TeaCatalog/03.png';
import tea03Webp from '../images/TeaCatalog/03.webp';
import tea04 from '../images/TeaCatalog/04.png';
import tea04Webp from '../images/TeaCatalog/04.webp';
import tea05 from '../images/TeaCatalog/05.png';
import tea05Webp from '../images/TeaCatalog/05.webp';
import tea06 from '../images/TeaCatalog/06.png';
import tea06Webp from '../images/TeaCatalog/06.webp';
import tea07 from '../images/TeaCatalog/07.png';
import tea07Webp from '../images/TeaCatalog/07.webp';
import wending01 from '../images/Wending Products/01.png';
import wending01Webp from '../images/Wending Products/01.webp';
import healthyDiet01 from '../images/HealthyDiet/01.png';
import healthyDiet01Webp from '../images/HealthyDiet/01.webp';



export const icons = [
  <HeaderIcon1 />,
  <HeaderIcon2 />,
  <HeaderIcon3 />,
]

export const catalog = [
  {
    img: catalog01,
    imgWebp: catalog01Webp,
    text: 'Свежеобжаренный кофе',
    btn: 'Купить',
    link: 'coffee_catalog',
  },
  {
    img: catalog02,
    imgWebp: catalog02Webp,
    text: 'Чай и кофейные напитки',
    btn: 'Купить',
    link: 'tea_catalog',
  },
  {
    img: catalog03,
    imgWebp: catalog03Webp,
    text: 'Продукция для вендинга',
    btn: 'Купить',
    link: 'wending_products',
  },
  {
    img: catalog04,
    imgWebp: catalog04Webp,
    text: 'Здоровое питание',
    btn: 'Купить',
    link: 'healthy_diet',
  },
]

export const discountItemPics = [
  discImg01,//0
  discImg01Webp,
  coffee,//1
  coffeeWebp,
  dots,//2
  stars,//3
  starsWebp,
  procent,//4
  procentWebp,
]

export const advantagesPics = [
  advantages01,
  advantages01Webp,
  advantagesicon1,
  advantagesicon2,
  advantagesicon3,
]

export const socialNetwork = [
  socialNetworksIcon01,
  socialNetworksIphones,
  socialNetworksIphonesWebp,
  socialNetworksNext,
]

export const productRangeIcons = [
  {
    img: <Icon1 />,
    text: 'Турка',
  },
  {
    img: <Icon2 />,
    text: 'Френч-пресс',
  },
  {
    img: <Icon3 />,
    text: 'Мока',
  },
  {
    img: <Icon4 />,
    text: 'Эспрессо',
  },
  {
    img: <Icon5 />,
    text: 'Воронка'
  },
  {
    img: <Icon6 />,
    text: 'Аэропресс'
  },
  {
    img: <Icon7 />,
    text: 'Чашка'
  },
  {
    img: <Icon8 />,
    text: 'Автомат'
  }
]

export const productRangePic = [
  { img: CatalogCoffee5, imgWebp: CatalogCoffee5Webp },
  { img: CatalogCoffee4, imgWebp: CatalogCoffee4Webp },
  { img: CatalogCoffee3, imgWebp: CatalogCoffee3Webp },
  { img: CatalogCoffee2, imgWebp: CatalogCoffee2Webp },
  { img: CatalogCoffee1, imgWebp: CatalogCoffee1Webp }]

export const teaRange = [
  {
    img: tea01,
    imgWebp: tea01Webp,
    text: 'Черный чай'
  },
  {
    img: tea02,
    imgWebp: tea02Webp,
    text: 'Зеленый чай'
  },
  {
    img: tea03,
    imgWebp: tea03Webp,
    text: 'Молочный улунг'
  },
  {
    img: '',
    text: false
  },
  {
    img: tea04,
    imgWebp: tea04Webp,
    text: 'Травяной чай'
  },
  {
    img: tea05,
    imgWebp: tea05Webp,
    text: 'Матча'
  },
  {
    img: tea06,
    imgWebp: tea06Webp,
    text: 'Пуэр'
  },
  {
    img: tea07,
    imgWebp: tea07Webp,
    text: 'Кофейные напитки'
  },
]

export const wendingRange = [
  {
    img: wending01,
    imgWebp: wending01Webp,
    text: 'Гранулированный кофе'
  },
  {
    img: wending01,
    imgWebp: wending01Webp,
    text: 'Гранулированный цикорий'
  },
  {
    img: wending01,
    imgWebp: wending01Webp,
    text: 'Зерновой кофе'
  },
  {
    img: '',
    text: false
  },
  {
    img: wending01,
    imgWebp: wending01Webp,
    text: 'Гранулированный какао'
  },
  {
    img: wending01,
    imgWebp: wending01Webp,
    text: 'Гранулированные кофейные напитки'
  },
  {
    img: wending01,
    imgWebp: wending01Webp,
    text: 'Кофе порошкообразный'
  },
  {
    img: wending01,
    imgWebp: wending01Webp,
    text: 'Сухое молоко гранулированное'
  },
]

export const foodRange = [
  {
    img: healthyDiet01,
    imgWebp: healthyDiet01Webp,
    text: 'Цикорий и корень цикория'
  },
  {
    img: healthyDiet01,
    imgWebp: healthyDiet01Webp,
    text: 'Ячменные напитки'
  },
  {
    img: '',
    text: false
  },
  {
    img: healthyDiet01,
    imgWebp: healthyDiet01Webp,
    text: 'Напитки для здоровья'
  },
  {
    img: healthyDiet01,
    imgWebp: healthyDiet01Webp,
    text: 'Протеиновые смеси'
  },
  {
    img: healthyDiet01,
    imgWebp: healthyDiet01Webp,
    text: 'Толокняные каши'
  },
]
